export default __webpack_public_path__ + "static/media/bars.fdc41a34.svg";